<template>
	<div class="convention-hall page">
		<van-nav-bar class="nav-bar" :title="this.$t('选妃')" />
		<div class="banner">
			<div class="swiper-slide">
				<div class="banner_img van-image">
					<img class="van-image__img" src="img/banner.gif">
				</div>
			</div>
		</div>
		<div class="convention-item">
			<van-tabs animated sticky line-width="100px" :swipeable="true">
				<van-tab title="VIP">
					<div class="scroll_wrap">
						<div class="list_wrap" >
							<div class="marque-list" v-for="(item, index) in duplicatedItems" :key="index">
								<div class="item-left">
									<img class="item-img" :src="item.img">
								</div>
								<div class="item-right">
									{{item.content}}
								</div>
							</div>
						</div>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				datalist:[]
			};
		},
		methods: {
			getChatInfo(){
			  this.$http({
			    method: 'get',
			    url: 'sys_get_chat'
			  }).then(res=>{
				  this.datalist = res.data
			  })
			},

		},
		computed: {
		    // 克隆一份，形成无缝循环
		    duplicatedItems() {
		      return [...this.datalist, ...this.datalist];
		    }
		  },
		created() {
			this.getChatInfo()
		}
	};
</script>

<style lang="less" scoped>
	.scroll_wrap {
		box-sizing: border-box;
		padding: 20px 10px;
		width: 90%;
		margin: 20px auto;
		height: 800px;
		overflow: hidden;
		border-radius: 10px;
	}
	
	.list_wrap {
		animation: scroll-up linear infinite;
		animation-duration: 200s; /* 滑完整个高度所需时间 */
	}
	
	.marque-list {
		width: 100%;
			height: 160px;
		  padding: 0 12px;
		  margin: 20px 0;
		  line-height: 28px;
		  .item-left{
			  float: left;
			  width: 20%;
			  text-align: center;
			  .item-img{
				  width: 80px;
				  height: 80px;
				  border-radius: 40px;
			  }
		  }
		  .item-right{
			  float: left;
			  width: 80%;
			  background: #fff;
			  box-sizing: border-box;
			  padding: 10px 20px;
			  border-radius: 10px;
		  }
	}
	@keyframes scroll-up {
	  0% {
	    transform: translateY(0);
	  }
	  100% {
	    transform: translateY(-50%);; /* 总高度 = item 高度 * 项数 */
	  }
	}
	.page {
		position: absolute !important;
		top: 0;
		left: 0;
		right: 0;
		// background-color: #f2f2f5;
	}

	.nav-bar {
		// background: linear-gradient(90deg, #7e5678, #e6c3a1);
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
		height: 100px;
	}

	.van-nav-bar {
		line-height: 50px;
	}

	::v-deep .van-nav-bar__title {
		max-width: 60%;
		margin: 0 auto;
		color: #ffffff;
		font-size: 35px;
	}

	::v-deep .van-nav-bar__content {
		height: 100px;
	}
	::v-deep .van-tab__pane-wrapper{
		padding-bottom: 80px;
		background-color: #f2f2f5;
	}

	.van-sidebar {
		width: 180px;
	}

	.convention-hall {
		display: flex;
		flex-direction: column;
		bottom: 20px;
		background: #f2f2f5;
	}

	::v-deep .van-tab {
		font-size: 30px;
		line-height: 100px;
		font-weight: bold;
		color: #c571cf;
	}

	::v-deep .van-tabs__line {
		background-color: #7e5678;
	}

	::v-deep .van-tabs--line .van-tabs__wrap {
		height: 100px;
	}

	::v-deep .van-tabs__wrap--scrollable .van-tab {
		padding: 0 23px;
	}

	.horizontalItem {
		display: flex;
		border-bottom: 1px solid #eee;
		padding: 2.667vw 0 4vw;
	}

	.horizontalItem .imgBox {
		position: relative;
		overflow: hidden;
		border-radius: 1.067vw;
		margin-right: 2.667vw;
	}

	.horizontalItem .imgBox>span {
		position: absolute;
		z-index: 9;
		background-color: #ebcaaf;
		color: #8d684b;
		transform: rotate(45deg);
		width: 20vw;
		height: 20vw;
		top: -11vw;
		right: -11vw;
	}

	.horizontalItem .imgBox>span>i {
		position: absolute;
		bottom: .667vw;
		left: 50%;
		transform: translateX(-50%);
		font-weight: 700;
		font-size: 4vw;
	}

	.horizontalItem .top {
		display: flex;
	}

	.horizontalItem .top>div:first-child,
	.horizontalItem .top>div:nth-child(2) {
		background: linear-gradient(180deg, #e7caaf, #fff7ed);
		color: #a4826b;
		font-weight: 600;
		font-size: 3vw;
		padding: .4vw;
		margin-right: 1.333vw;
	}

	.horizontalItem .tags {
		display: flex;
		margin: .667vw 0 .667vw;
		flex-wrap: wrap;
	}

	.horizontalItem .tags>.van-tag {
		padding: .667vw;
		font-size: 3.333vw;
		margin: 0 .667vw .667vw 0;
		border-radius: 1.067vw;
		line-height: 4vw;
	}

	.horizontalItem .yueta {
		background: linear-gradient(90deg, #df35ad, #4f1db5);
		color: #fff;
		border-radius: 1.067vw;
		padding: 1.333vw 0;
		text-align: center;
		font-size: 4vw;
	}
</style>